import _omit from "lodash/omit";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet } from 'react-native';
import View from 'react-native-web-ui-components/View';
import Text from 'react-native-web-ui-components/Text';
import Link from 'react-native-web-ui-components/Link';
import StylePropType from 'react-native-web-ui-components/StylePropType';
import TextInputWidget from '../TextInputWidget';
import EditHandle from './EditHandle';
import SaveHandle from './SaveHandle';
import CancelHandle from './CancelHandle';
const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginBottom: 10
  },
  defaults: {
    height: 40
  },
  fullWidth: {
    width: '100%'
  },
  auto: {
    marginBottom: 0
  },
  main: {
    flex: 1
  },
  text: {
    height: 40,
    borderWidth: 1,
    borderColor: 'transparent',
    lineHeight: 40,
    overflow: 'hidden'
  }
});

class TextWidget extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.value !== prevState.value) {
      return {
        value: nextProps.value,
        displayValue: nextProps.value
      };
    }

    return null;
  }

  constructor(props) {
    super(props);

    _defineProperty(this, "onChange", value => this.setState({
      displayValue: value
    }));

    _defineProperty(this, "onSave", () => {
      const {
        name,
        onChange
      } = this.props;
      const {
        displayValue
      } = this.state;
      this.setState({
        editing: false,
        value: displayValue
      });
      setTimeout(() => onChange(displayValue, name));
    });

    _defineProperty(this, "onCancel", () => {
      const {
        value
      } = this.state;
      this.setState({
        editing: false,
        displayValue: value
      });
    });

    _defineProperty(this, "onEdit", () => this.setState({
      editing: true
    }));

    const {
      value: _value
    } = props;
    this.state = {
      value: _value,
      editing: false,
      displayValue: _value
    };
  }

  renderChildren(element) {
    if (typeof element === 'function') {
      const Component = element;
      return /*#__PURE__*/React.createElement(Component, this.props);
    }

    return element;
  }

  render() {
    const {
      to,
      theme,
      auto,
      style,
      textStyle,
      textContainerStyle,
      inputStyle,
      inputContainerStyle,
      editable,
      EditComponent,
      SaveComponent,
      CancelComponent,
      children,
      textParser
    } = this.props;
    const {
      editing,
      displayValue,
      value
    } = this.state;
    let href = null;

    if (to) {
      href = typeof to === 'function' ? to(this.props) : to;
    }

    return /*#__PURE__*/React.createElement(View, {
      style: [styles.container, styles.defaults, auto ? styles.auto : styles.fullWidth, style]
    }, editing ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
      style: [auto ? null : styles.main, inputContainerStyle]
    }, /*#__PURE__*/React.createElement(TextInputWidget, _extends({}, _omit(this.props, 'textParser'), {
      auto: true,
      style: [styles.fullWidth, inputStyle],
      value: displayValue,
      onChange: this.onChange
    })), this.renderChildren(children)), /*#__PURE__*/React.createElement(SaveComponent, _extends({}, this.props, {
      to: undefined,
      onPress: this.onSave
    })), /*#__PURE__*/React.createElement(CancelComponent, _extends({}, this.props, {
      to: undefined,
      onPress: this.onCancel
    }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
      style: [auto ? null : styles.main, textContainerStyle]
    }, !href ? /*#__PURE__*/React.createElement(Text, {
      style: [theme.input.regular.text, styles.defaults, styles.text, styles.fullWidth, textStyle]
    }, value !== null && value !== undefined ? value : '') : /*#__PURE__*/React.createElement(Link, {
      to: href,
      blank: true,
      type: theme.colors.primary,
      style: [styles.defaults, styles.text, styles.fullWidth, textStyle]
    }, textParser(value, this.props)), this.renderChildren(children)), editable ? /*#__PURE__*/React.createElement(EditComponent, _extends({}, this.props, {
      to: undefined,
      onPress: this.onEdit
    })) : null));
  }

}

_defineProperty(TextWidget, "propTypes", {
  theme: PropTypes.shape().isRequired,
  name: PropTypes.string.isRequired,
  textParser: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  auto: PropTypes.bool,
  style: StylePropType,
  textStyle: StylePropType,
  textContainerStyle: StylePropType,
  inputStyle: StylePropType,
  inputContainerStyle: StylePropType,
  editable: PropTypes.bool,
  EditComponent: PropTypes.elementType,
  SaveComponent: PropTypes.elementType,
  CancelComponent: PropTypes.elementType,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType])
});

_defineProperty(TextWidget, "defaultProps", {
  value: null,
  to: null,
  auto: false,
  textParser: value => value !== null && value !== undefined ? value : '',
  style: null,
  textStyle: null,
  textContainerStyle: null,
  inputStyle: null,
  inputContainerStyle: null,
  editable: true,
  EditComponent: EditHandle,
  SaveComponent: SaveHandle,
  CancelComponent: CancelHandle,
  children: null
});

export default TextWidget;